// frontend/src/components/capacitor/CapacitorFeaturesDrawer.tsx
import { Drawer } from 'vaul'
import { PREMIUM_PLUS_ENABLED } from '../../featureFlags'
import './Capacitor.css'

interface Props {
  open: boolean
  onClose: () => void
}

function Check() {
  return <span className="cf-check">✓</span>
}
function Cross() {
  return <span className="cf-cross">✗</span>
}

export function CapacitorFeaturesDrawer({ open, onClose }: Props) {
  return (
    <Drawer.Root open={open} onOpenChange={v => { if (!v) onClose() }}>
      <Drawer.Portal>
        <Drawer.Overlay className="cp-drawer-overlay" />
        <Drawer.Content className="cp-drawer cf-drawer">
          <div className="cp-drawer-handle" />
          <Drawer.Title className="cp-drawer-title">Was bekomme ich?</Drawer.Title>

          <div className="cp-drawer-body">

            {/* Free */}
            <div className="cf-tier cf-tier--free">
              <div className="cf-tier-header">
                <span className="cf-tier-name">Vorschau</span>
                <span className="cf-tier-price">Kostenlos</span>
              </div>
              <ul className="cf-list">
                <li><Check /> Live-Vorschau (50 Nachrichten)</li>
                <li><Check /> Farben &amp; Schriftgröße anpassen</li>
                <li><Cross /> Kein PDF-Download</li>
                <li><Cross /> Wasserzeichen in der Vorschau</li>
              </ul>
            </div>

            <div className="cp-drawer-divider" />

            {/* Premium */}
            <div className="cf-tier cf-tier--premium">
              <div className="cf-tier-header">
                <span className="cf-tier-name">PDF Export</span>
                <span className="cf-tier-price">€4,99</span>
              </div>
              <ul className="cf-list">
                <li><Check /> Vollständiges PDF (alle Nachrichten)</li>
                <li><Check /> Ohne Wasserzeichen</li>
                <li><Check /> Thumbnails für Bilder &amp; Videos</li>
                <li><Check /> Icons für Dokumente (PDF, Word, Excel…)</li>
                <li><Check /> Audio-Platzhalter mit Dateiname</li>
                <li><Check /> Anpassbares Design (Farben, Schrift)</li>
              </ul>
            </div>

            {PREMIUM_PLUS_ENABLED && (<>
            <div className="cp-drawer-divider" />

            {/* Premium+ */}
            <div className="cf-tier cf-tier--plus">
              <div className="cf-tier-header">
                <span className="cf-tier-name">PDF + Medien <span className="cp-purchase-badge">Empfohlen</span></span>
                <span className="cf-tier-price">€5,99</span>
              </div>
              <ul className="cf-list">
                <li><Check /> Alles aus „PDF Export"</li>
                <li><Check /> Klickbare Download-Links im PDF</li>
                <li><Check /> Bilder, Videos &amp; Audio 1 Jahr online</li>
                <li><Check /> Bis zu 500 MB pro Export</li>
              </ul>

              <div className="cf-cloud-box">
                <p className="cf-cloud-title">☁️ Cloud-Hosting Details</p>
                <p className="cf-cloud-row"><strong>Formate:</strong> JPG, PNG, WebP, HEIC · MP4, MOV · MP3, OGG, AAC, OPUS · PDF, DOCX, XLSX, PPTX</p>
                <p className="cf-cloud-row"><strong>Limit:</strong> 500 MB pro Export — bei Überschreitung werden die ersten Dateien gehostet</p>
                <p className="cf-cloud-row"><strong>Laufzeit:</strong> 1 Jahr ab Kauf, danach automatisch gelöscht</p>
              </div>
            </div>
            </>)}

          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
}
